/* src/app/timeline-skip/modals/skip-round-edit-modal/skip-round-edit-modal.component.scss */
/*# sourceMappingURL=skip-round-edit-modal.component.css.map */
